import accordion from './accordion';
import autocomplete from './autocomplete';
import avatar from './avatar';
import badge from './badge';
import button from './button';
import card from './card';
import chip from './chip';
import datatable from './datatable';
import dataview from './dataview';
import datepicker from './datepicker';
import dialog from './dialog';
import divider from './divider';
import fieldset from './fieldset';
import galleria from './galleria';
import image from './image';
import inlinemessage from './inlinemessage';
import inputtext from './inputtext';
import megamenu from './megamenu';
import menubar from './menubar';
import message from './message';
import multiselect from './multiselect';
import organizationchart from './organizationchart';
import paginator from './paginator';
import progressspinner from './progressspinner';
import select from './select';
import slider from './slider';
import stepper from './stepper';
import tabs from './tabs';
import tag from './tag';
import textarea from './textarea';
import toast from './toast';
import togglebutton from './togglebutton';
import toggleswitch from './toggleswitch';
import tooltip from './tooltip';
import tree from './tree';
import treeselect from './treeselect';
import treetable from './treetable';

export const components = {
	inputtext,
	button,
	toggleswitch,
	autocomplete,
	datepicker,
	badge,
	avatar,
	chip,
	message,
	inlinemessage,
	card,
	tag,
	select,
	textarea,
	multiselect,
	slider,
	togglebutton,
	treeselect,
	dataview,
	accordion,
	divider,
	fieldset,
	tabs,
	dialog,
	tooltip,
	megamenu,
	menubar,
	organizationchart,
	paginator,
	datatable,
	tree,
	image,
	treetable,
	toast,
	galleria,
	stepper,
	progressspinner,
};
